import { useEffect, useState } from "react";
import app from "nystem";

const useLanguage = () => {
  const [lang, setLang] = useState(app.settings.lang);

  useEffect(() => {
    const onLanguage = ({ lang }) => setLang(lang);

    setLang(app.settings.lang);
    app.on("language", onLanguage);
    return () => {
      app.off("language", onLanguage);
    };
  }, []);

  return lang;
};

export default useLanguage;
